import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { MaterialIcon, Button } from '@pearsontechnology/aero-components';
import messages from './messages';
import {
  BannerNotificationContainer,
  BannerNotificationIcon,
  BannerNotificationWarning,
  BannerNotificationMessage,
  BannerNotificationCloseIcon,
} from './styles';

const BannerNotification = ({ message, type, theme, onClose, getBannerHeight, showOkButton = true, isReviewerBanner = false }) => {
  const bannerHeight = useRef();

  useEffect(() => {
    const boundingRect = bannerHeight.current.getBoundingClientRect();
    const { height } = boundingRect;
    getBannerHeight(Math.round(height));
  }, [message, getBannerHeight]);

  return (<BannerNotificationContainer type={type} theme={theme} ref={bannerHeight} isReviewerBanner={isReviewerBanner}>
    {!isReviewerBanner && <MaterialIcon as={BannerNotificationIcon} id="warning" theme={theme} /> }
    <BannerNotificationWarning theme={theme} isReviewerBanner={isReviewerBanner}>
      <BannerNotificationMessage dangerouslySetInnerHTML={{ __html: message }} />
    </BannerNotificationWarning>
    {showOkButton && <Button as={BannerNotificationCloseIcon} white onClick={onClose} type={type} theme={theme}>
      {intl.formatMessage(messages.ok)}
    </Button>}
  </BannerNotificationContainer>);
};

BannerNotification.prototypes = {
  message: PropTypes.string,
  type: PropTypes.string,
  onClose: PropTypes.func,
};
export default BannerNotification;